// @flow strict
import * as React from 'react';
import { FormGrid, FormGridRow, FormGridCell, TextInput, TextArea } from '@ansarada/ace-react';

export const BillingDetails = ({
  values,
  setFieldValue,
  touched,
  errors,
  validateForm,
  fieldStatusByName,
  setFieldTouchedByName,
}: any) => {
  React.useEffect(() => {
    validateForm();
  }, []);

  return (
    <FormGrid>
      <FormGridRow>
        <FormGridCell
          labelText="Client's first name"
          errors={touched.InvoiceFirstName && errors.InvoiceFirstName}
          errorPosition="Bottom"
        >
          <TextInput
            id="DigitalQuoteForm_ClientFirstName"
            value={values.InvoiceFirstName}
            onChangeValue={newVal => setFieldValue('InvoiceFirstName', newVal)}
            status={fieldStatusByName('InvoiceFirstName') === 'Bad' ? 'Bad' : 'Good'}
            onBlur={() => {
              setFieldTouchedByName('InvoiceFirstName')();
            }}
          />
        </FormGridCell>
        <FormGridCell
          labelText="Client's last name"
          errors={touched.InvoiceLastName && errors.InvoiceLastName}
          errorPosition="Bottom"
        >
          <TextInput
            id="DigitalQuoteForm_ClientLastName"
            value={values.InvoiceLastName}
            onChangeValue={newVal => setFieldValue('InvoiceLastName', newVal)}
            status={fieldStatusByName('InvoiceLastName') === 'Bad' ? 'Bad' : 'Good'}
            onBlur={() => {
              setFieldTouchedByName('InvoiceLastName')();
            }}
          />
        </FormGridCell>
      </FormGridRow>
      <FormGridRow>
        <FormGridCell
          labelText="Client's company name"
          errors={touched.InvoiceCompany && errors.InvoiceCompany}
          errorPosition="Bottom"
        >
          <TextInput
            id="DigitalQuoteForm_ClientCompanyName"
            value={values.InvoiceCompany}
            onChangeValue={newVal => setFieldValue('InvoiceCompany', newVal)}
            status={fieldStatusByName('InvoiceCompany') === 'Bad' ? 'Bad' : 'Good'}
            onBlur={() => {
              setFieldTouchedByName('InvoiceCompany')();
            }}
          />
        </FormGridCell>
      </FormGridRow>
      <FormGridRow>
        <FormGridCell
          labelText="Client's email"
          hint="Don't worry we won't send anything to your client"
          hintPosition="Bottom"
          errors={touched.InvoiceEmail && errors.InvoiceEmail}
          errorPosition="Bottom"
        >
          <TextInput
            id="DigitalQuoteForm_ClientEmail"
            value={values.InvoiceEmail}
            onChangeValue={newVal => setFieldValue('InvoiceEmail', newVal)}
            status={fieldStatusByName('InvoiceEmail') === 'Bad' ? 'Bad' : 'Good'}
            onBlur={() => {
              setFieldTouchedByName('InvoiceEmail')();
            }}
          />
        </FormGridCell>
      </FormGridRow>
      <FormGridRow>
        <FormGridCell
          labelText="Client's address"
          errors={touched.InvoiceAddress && errors.InvoiceAddress}
          errorPosition="Bottom"
        >
          <TextArea
            id="DigitalQuoteForm_ClientAddress"
            value={values.InvoiceAddress}
            onChangeValue={newVal => setFieldValue('InvoiceAddress', newVal)}
            status={fieldStatusByName('InvoiceAddress') === 'Bad' ? 'Bad' : 'Good'}
            onBlur={() => {
              setFieldTouchedByName('InvoiceAddress')();
            }}
          />
        </FormGridCell>
      </FormGridRow>
    </FormGrid>
  );
};
